export const positiveWords = [
    "Brilliant", "Resilient", "Unstoppable", "Extraordinary", "Magnificent",
    "Phenomenal", "Outstanding", "Remarkable", "Exceptional", "Masterful",
    "Innovative", "Visionary", "Empowered", "Limitless", "Triumphant",
    "Radiant", "Flourishing", "Tenacious", "Victorious", "Accomplished",
    "Enlightened", "Fearless", "Determined", "Passionate", "Authentic",
    "Inspiring", "Powerful", "Confident", "Focused", "Driven",
    "Luminous", "Invincible", "Unbeatable", "Spectacular", "Glorious",
    "Incredible", "Stellar", "Superb", "Excellent", "Magnificent",
    "Dynamic", "Energetic", "Vibrant", "Spirited", "Enthusiastic",
    "Resolute", "Steadfast", "Unwavering", "Dedicated", "Persevering"
];
